import React from 'react'

const localeTypes = [
  { name: "Ristoranti", image: "https://images.unsplash.com/photo-1517248135467-4c7edcad34c4?q=80&w=600&h=800&auto=format&fit=crop" },
  { name: "Bar & Caffè", image: "https://images.unsplash.com/photo-1554118811-1e0d58224f24?q=80&w=600&h=800&auto=format&fit=crop" },
  { name: "Hotel & Spa", image: "https://images.unsplash.com/photo-1566073771259-6a8506099945?q=80&w=600&h=800&auto=format&fit=crop" },
  { name: "Lounge & Wine Bar", image: "https://images.unsplash.com/photo-1572116469696-31de0f17cc34?q=80&w=600&h=800&auto=format&fit=crop" }
]

const EventTypes = () => {
  return (
    <section id="locali" className="py-20 bg-white">
      <div className="container mx-auto px-6">
        <div className="text-center mb-16">
          <h2 className="text-4xl font-serif font-bold text-brand-green mb-4">Per Ogni Tipo di Locale</h2>
          <p className="text-lg text-gray-600 max-w-2xl mx-auto">Specializzati nell'ospitalità, creiamo allestimenti verdi su misura per ogni tipologia di business.</p>
        </div>
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8">
          {localeTypes.map((locale, index) => (
            <div key={index} className="relative group overflow-hidden rounded-lg shadow-xl aspect-[3/4]">
              <img src={locale.image} alt={locale.name} className="w-full h-full object-cover transition-transform duration-500 group-hover:scale-110" loading="lazy" />
              <div className="absolute inset-0 bg-gradient-to-t from-black/70 to-transparent"></div>
              <div className="absolute bottom-0 left-0 p-6">
                <h3 className="text-white text-3xl font-serif">{locale.name}</h3>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  )
}

export default EventTypes